<template>
  <div>
    <div class="responsibility-assignment-header-card">
      <div class="d-flex align-center">
        <v-img :width="50" :height="50" :src="require('@components/assets/link-icon.svg')" alt="assignment-header-bg" />
        <v-img :width="50" :height="50" :src="require('@components/assets/responsibiliy-icon.svg')" alt="assignment-header-bg" />
      </div>
      <div>
        <div class="d-flex gap">
          <Importance :importance="responsibilityImportance" />
          <ExNewBadgeVue v-if="showNewBadge"/>
          <div class="responsibility-text"><span v-if="show_codes">{{ responsibilityCode }}</span> <span class="name">{{ responsibilityName }}</span></div>
        </div>
        <div class="d-flex gap ms-4 role-item">
          <Icon name="line_pointer_icon" class="line-pointer"/>
          <Importance :importance="roleImportance" :type="false" />
          <Icon name="org_icon_role" class="roleIcon"/>
          <div class="role-text"><span v-if="show_codes">{{ roleCode }}</span> <span class="roleName">{{ roleName }}</span></div>
        </div>
        <div class="d-flex gap ms-8 position-item">
          <Icon name="line_pointer_icon" class="line-pointer1"/>
          <Importance :importance="positionImportance" :type="false" />
          <Icon name="org_icon_position" class="posIcon"/>
          <AsEmployeeCommitmentCard :commitment="positionCommitment" :labelShow="false" />
          <div class="position-text"><span v-if="show_codes">{{ positionCode }}</span> <span class="posName">{{ positionName }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from "@components/icons/Icon.vue";
import Importance from '@components/importance/Importance.vue';
import ExNewBadgeVue from "@components/ExNewBadge/ExNewBadge.vue";
import AsEmployeeCommitmentCard from "@components/AsEmployeeCommitmentCard/AsEmployeeCommitmentCard";

const props = defineProps({
  responsibilityCode: {
    type: String,
    default: "#9999",
  },
  responsibilityName: {
    type: String,
    default: "Responsibility Name",
  },
  roleCode: {
    type: String,
    default: "#245",
  },
  roleName: {
    type: String,
    default: "Implement CAPEX initiatives",
  },
  positionCode: {
    type: String,
    default: "#4567",
  },
  positionName: {
    type: String,
    default: "General Manager",
  },
  responsibilityImportance: {
    type: Number,
    default: 0,
  },
  roleImportance: {
    type: Number,
    default: 0,
  },
  positionImportance: {
    type: Number,
    default: 0,
  },
  positionCommitment: {
    type: String,
    default: "Primary",
  },
  assignedOn: {
    type: String,
    default: "2025-09-01"
  },
  newDuration: {
    type: Number,
    default: 15,
  },
  show_codes: {
    type: Boolean,
    default: false
  }
});

const showNewBadge = computed(() => {
  const today = new Date();
  const todayPlusDuration = new Date();
  todayPlusDuration.setDate(today.getDate() + props.newDuration);
  const assignedDate = new Date(props.assignedOn);
  return assignedDate < todayPlusDuration;
});
</script>

<style>
.responsibility-assignment-header-card {
  display: flex;
  align-items: center;
  gap: 8px;
}
.responsibility-assignment-header-card .importance-container {
  height: 22px !important;
}
.responsibility-assignment-header-card .role-item .importance-container {
  height: 18px !important;
  margin-top: 1px;
  margin-left: -2px;
}
.responsibility-assignment-header-card .position-item .importance-container {
  height: 18px !important;
  margin-top: 1px;
  margin-left: -2px;
}
.responsibility-assignment-header-card .badge-box {
  height: 24px;
  margin-top: -1px;
  padding: 3px 6px !important;
}
.responsibility-assignment-header-card .line-pointer {
  margin-left: -6px;
  margin-top: 8px;
}
.responsibility-assignment-header-card .line-pointer1 {
  margin-left: -2px;
  margin-top: 8px;
}
.responsibility-assignment-header-card .as-employee-com {
  padding: 0px !important;
  margin-top: -5px;
  margin-left: -1px;
  margin-right: -2px;
}
.responsibility-assignment-header-card .as-employee-com .employee-lbl-icon {
  padding: 0px !important;
}
.responsibility-assignment-header-card .as-employee-com .employee-lbl-icon svg {
  width: 18px;
  margin-left: -1px;
}
.responsibility-assignment-header-card .responsibility-text {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #98A2B3;
  margin-bottom: 4px;
}
.responsibility-assignment-header-card .responsibility-text .name {
  color: #101828;
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 20px;
  line-height: 24px;
}
.responsibility-assignment-header-card .role-text {
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #98A2B3;
  margin-bottom: 4px;
  margin-left: -1px;
}
.responsibility-assignment-header-card .role-text .roleName {
  font-weight: 500;
  color: #101828;
}
.responsibility-assignment-header-card .position-text {
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #98A2B3;
  margin-left: 0px;
}
.responsibility-assignment-header-card .position-text .posName {
  font-weight: 500;
  color: #101828;
}
.responsibility-assignment-header-card .gap {
  gap: 7px;
}
.responsibility-assignment-header-card .responsibility-sec {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
}
.responsibility-assignment-header-card .responsibility-sec .resp-code {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #475467;
}
.responsibility-assignment-header-card .responsibility-sec .resp-name {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #101828;
}
.responsibility-assignment-header-card .roleIcon {
  width: 16px;
  margin-left: -3px;
}
.responsibility-assignment-header-card .posIcon {
  width: 16px;
  margin-left: -3px;
}
.responsibility-assignment-header-card .role-item .importance-container .bar {
  min-width: 5px !important;
  margin-left: 0px !important;
}
.responsibility-assignment-header-card .position-item .importance-container .bar {
  min-width: 5px !important;
  margin-left: 0px !important;
}
</style>